<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        :title="
          baseView.mode == 'create'
            ? 'Create Product Filter Group'
            : `Product Filter Group #${baseView.id}`
        "
      />
    </template>

    <div class="css-v2 product-filter-group">
      <DxToolbar
        class="view-toolbar product-filter-group-toolbar"
        ref="toolbar-header"
      >
        <DxItem
          widget="dxForm"
          location="before"
          :options="{
            formData: model,
            items: toolbarFormItems,
            validationGroup: formsConfig.validationGroup,
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
            requiredMark: '',
          }"
          locate-in-menu="auto"
          :disabled="baseView.mode == 'review' ? true : false"
          ref="product-filter-group-toolbar-form"
        ></DxItem>
        <DxItem
          widget="dxForm"
          location="after"
          :disabled="baseView.mode == 'review' ? true : false"
          :options="{
            formData: model,
            items: toolbarActiveItems,
            validationGroup: 'toolbarForm',
            labelLocation: 'left',
          }"
          locate-in-menu="auto"
        ></DxItem>
        <DxItem
          :options="toolbar.audit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode != 'create'"
        />
        <DxItem
          :options="toolbar.edit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />
        <DxItem
          :options="toolbar.save"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode != 'review'"
          ref="headerSaveMenu"
        />
      </DxToolbar>
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="productFilterGroupProductDataSourceConfig"
            :columns="productFilterGroupProductColumns"
            :height="gridHeight - toolBarHeight - 25"
            @toolbar-preparing="onToolbarPreparingProductFilterGroupProductGrid"
            @editor-preparing="onEditorPreparing"
            ref="product-grid"
            :keyExpr="currentProductListKey"
            :selection="{
              mode: 'multiple',
              selectAllMode: 'allPages',
              showCheckBoxesMode: 'always',
            }"
            :selected-row-keys="productGridKeys"
            @selection-changed="onProductGridSelectionChanged"
            @content-ready="addGridNoResults($event, noDataMessageLeftContent)"
          >
            <template #item-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data[currentProductDescriptionDataField]"
                :code="data.data[currentProductCodeDataField]"
              />
            </template>

            <template #item-type-cell-template="{ data }">
              <span>{{ formatProductType(data.data.Type) }}</span>
            </template>
          </dx-data-grid>
        </template>

        <template #rightContent>
          <dx-data-grid
            :columns="productFilterGroupCustomerColumns"
            :data-source="productFilterGroupCustomerDataSourceConfig"
            :height="gridHeight - toolBarHeight - 25"
            @toolbar-preparing="
              onToolbarPreparingProductFilterGroupCustomerGrid
            "
            @editor-preparing="onEditorPreparing"
            ref="customer-grid"
            :keyExpr="currentCustomerListKey"
            :selection="{
              mode: 'multiple',
              selectAllMode: 'allPages',
              showCheckBoxesMode: 'always',
            }"
            :selected-row-keys="customerGridKeys"
            @selection-changed="onCustomerGridSelectionChanged"
            @content-ready="addGridNoResults($event, noDataMessageRightContent)"
          >
            >
            <template #cust-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data[currentCustomerDescriptionDataField]"
                :code="data.data[currentCustomerCodeDataField]"
              />
            </template>

            <template #cust-type-cell-template="{ data }">
              <span>{{ formatCustomerType(data.data.Type) }}</span>
            </template>
          </dx-data-grid>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
let category1DataSource = ProductFilterGroupService.dataSourceConfig(
  "api/ProductCategory1",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let category2DataSource = ProductFilterGroupService.dataSourceConfig(
  "api/ProductCategory2",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let category3DataSource = ProductFilterGroupService.dataSourceConfig(
  "api/ProductCategory3",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let category4DataSource = ProductFilterGroupService.dataSourceConfig(
  "api/ProductCategory4",
  {
    select: "Code,Description,RecordId",
    key: "Code",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let productDataSource = ProductFilterGroupService.dataSourceConfig(
  "api/Product",
  {
    key: "Code",
    select: "Code,Description1,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description1", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let productSizeDataSource = ProductFilterGroupService.dataSourceConfig(
  "api/ProductSize",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

let productTypeDataSource = ProductFilterGroupService.dataSourceConfig(
  "api/ProductType",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

let customerTypeDataSource = ProductFilterGroupService.dataSourceConfig(
  "api/CustomerType",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

let customerGroupDataSource = ProductFilterGroupService.dataSourceConfig(
  "api/CustomerGroup",
  {
    key: "Code",
    select: "Code,Description,RecordId",
    preventPagination: true,
    sort: [{ selector: "Description", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

let customerDataSource = ProductFilterGroupService.dataSourceConfig(
  "api/Customer",
  {
    key: "Code",
    select: "Code,Name,RecordId",
    preventPagination: true,
    sort: [{ selector: "Name", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

import BaseViewMixin from "../../../v1/_mixins/base.view";
import { ProductFilterGroupService } from "../../../_services/api/settings/products/product-filter-group.service";
import { SettingsService } from "../../../_services/api/settings/graycorp/settings.service";
import validationEngine from "devextreme/ui/validation_engine";

/*
  History
    15May2026 (AE)
      - #71165 : 2061 - Automatic Invoice Surcharge - add new Type
        option 'Automatic Invoice Surcharge Inclusion', visibility
        gated by the 'Automatic Invoice Surcharge Inclusion Enabled'
        ApplicationFeatureSetting. In edit/review of an existing
        group already of this type, the option remains visible
        regardless of the setting so admins can still see/edit.
*/

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      automaticInvoiceSurchargeEnabled: false,
      currentProductView: null,
      currentCustomerView: null,
      productFilterGroupProductDataSourceConfig: [],
      productFilterGroupCustomerDataSourceConfig: [],
      productFilterGroupProducts: [],
      productFilterGroupCustomers: [],
      category1DataSourceConfig: [],
      category2DataSourceConfig: [],
      category3DataSourceConfig: [],
      category4DataSourceConfig: [],
      productDataSourceConfig: [],
      productTypeDataSourceConfig: [],
      productSizeDataSourceConfig: [],
      customerDataSourceConfig: [],
      customerTypeDataSourceConfig: [],
      customerGroupDataSourceConfig: [],
      model: {
        CustomerView: "",
        ProductView: "",
        CountDate: null,
        Description: "",
        Active: false,
        CreatedBy: "",
        DateCreated: "",
        ChangedBy: "",
        DateChanged: "",
        Type: undefined,
      },
      toolbar: {
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: () => {
            this.$logger.trackEventButtonClickSave();
            this.saveProductFilterGroup();
          },
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/product-filter-group/edit/${this.baseView.id}`,
            });
          },
        },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
    };
  },
  components: {},
  async created() {
    // load data sources
    this.showLoading(true);

    // 15May2026 (AE) - #71165 : Read the master switch for the
    // Automatic Invoice Surcharge Inclusion feature so we can decide
    // whether to expose its Type option in the dropdown below.
    try {
      const aisResponse = await SettingsService.getBySettingNameFromDb(
        "Automatic Invoice Surcharge Inclusion Enabled"
      );
      const aisSetting =
        aisResponse && aisResponse.data && aisResponse.data.value
          ? aisResponse.data.value[0]
          : null;
      this.automaticInvoiceSurchargeEnabled =
        aisSetting && aisSetting.SettingValue === "Y";
    } catch (e) {
      this.automaticInvoiceSurchargeEnabled = false;
    }

    await category1DataSource.load();
    this.category1DataSourceConfig = category1DataSource.items();

    await category2DataSource.load();
    this.category2DataSourceConfig = category2DataSource.items();

    await category3DataSource.load();
    this.category3DataSourceConfig = category3DataSource.items();

    await category4DataSource.load();
    this.category4DataSourceConfig = category4DataSource.items();

    await productDataSource.load();
    this.productDataSourceConfig = productDataSource.items();

    await productTypeDataSource.load();
    this.productTypeDataSourceConfig = productTypeDataSource.items();

    await productSizeDataSource.load();
    this.productSizeDataSourceConfig = productSizeDataSource.items();

    await customerDataSource.load();
    this.customerDataSourceConfig = customerDataSource.items();

    await customerTypeDataSource.load();
    this.customerTypeDataSourceConfig = customerTypeDataSource.items();

    await customerGroupDataSource.load();
    this.customerGroupDataSourceConfig = customerGroupDataSource.items();

    this.showLoading(false);

    // this.$refs["Customer Group"].repaint();

    if (this.baseView.mode !== "create") {
      let response = await ProductFilterGroupService.getProductFilterGroupByCode(
        this.baseView.id
      );
      this.model.Description = response.data.value[0].Description;
      this.model.Active = response.data.value[0].Inactive == "N";
      this.model.CreatedBy = response.data.value[0].CreatedBy;
      this.model.DateCreated = response.data.value[0].DateCreated;
      this.model.ChangedBy = response.data.value[0].ChangedBy;
      this.model.DateChanged = response.data.value[0].DateChanged;
      this.model.Type = response.data.value[0].Type;

      let customersResponse = await ProductFilterGroupService.getProductFilterGroupCustomersByCode(
        this.baseView.id
      );
      this.productFilterGroupCustomers = customersResponse.data.value;

      let productsResponse = await ProductFilterGroupService.getProductFilterGroupProductsByCode(
        this.baseView.id
      );
      this.productFilterGroupProducts = productsResponse.data.value;

      this.model.CustomerView = "Review";
      this.productFilterGroupCustomerDataSourceConfig = this.productFilterGroupCustomers;
      this.model.ProductView = "Review";
      this.productFilterGroupProductDataSourceConfig = this.productFilterGroupProducts;
    } else {
      this.model.CustomerView = "Customer Group";
      this.productFilterGroupCustomerDataSourceConfig = this.customerGroupDataSourceConfig;
      this.model.ProductView = "Category 1";
      this.productFilterGroupProductDataSourceConfig =
        this.category1DataSourceConfig;
      this.model.Type = "Available Products";
    }
  },
  computed: {
    noDataMessageRightContent() {
      let noDataMessageObject = {
        addNew: {},
      };

      if (this.currentCustomerView == "Customer") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Customers",
          message:
            "Customers must be in the system for them to appear here. Head over to the Customer screen to start adding them.",
        };
      } else if (this.currentCustomerView == "Review") {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Customers",
          message:
            "There are no customers added to the filter group yet.  Try changing the view and find the customers, groups or types that you want to add to the filter group.",
        };
      } else {
        noDataMessageObject = undefined;
      }

      return noDataMessageObject;
    },
    noDataMessageLeftContent() {
      let noDataMessageObject = {
        addNew: {},
      };

      if (this.currentProductView == "Product") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Products",
          message:
            "Products must be in the system for them to appear here. Head over to the Product screen to start adding them.",
        };
      } else if (this.currentProductView == "Review") {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Products",
          message:
            "There are no products added to the filter group yet.  Try changing the view and find the products or their categories that you want to add to the filter group.",
        };
      } else {
        noDataMessageObject = undefined;
      }

      return noDataMessageObject;
    },
    customerGridKeys() {
      let arrCT = [];
      let arrCG = [];
      let arrC = [];
      let arrReview = [];

      this.productFilterGroupCustomers.forEach((obj) => {
        if (this.model.CustomerView == "Review") arrReview.push(obj.RecordId);
        else if (obj.Type == "CT") arrCT.push(obj.Value);
        else if (obj.Type == "CG") arrCG.push(obj.Value);
        else if (obj.Type == "C") arrC.push(obj.Value);
      });

      if (this.model.CustomerView == "Review") return arrReview;
      else if (this.model.CustomerView == "Customer Group") return arrCG;
      else if (this.model.CustomerView == "Customer Type") return arrCT;
      else if (this.model.CustomerView == "Customer") return arrC;
      else return [];
    },
    productGridKeys() {
      let arrC1 = [];
      let arrC2 = [];
      let arrC3 = [];
      let arrC4 = [];
      let arrP = [];
      let arrPS = [];
      let arrPT = [];
      let arrReview = [];

      this.productFilterGroupProducts.forEach((obj) => {
        if (this.model.ProductView == "Review") arrReview.push(obj.RecordId);
        else if (obj.Type == "PC1") arrC1.push(obj.Value);
        else if (obj.Type == "PC2") arrC2.push(obj.Value);
        else if (obj.Type == "PC3") arrC3.push(obj.Value);
        else if (obj.Type == "PC4") arrC4.push(obj.Value);
        else if (obj.Type == "PT") arrPT.push(obj.Value);
        else if (obj.Type == "PS") arrPS.push(obj.Value);
        else if (obj.Type == "P") arrP.push(obj.Value);
      });

      if (this.model.ProductView == "Review") return arrReview;
      else if (this.model.ProductView == "Category 1") return arrC1;
      else if (this.model.ProductView == "Category 2") return arrC2;
      else if (this.model.ProductView == "Category 3") return arrC3;
      else if (this.model.ProductView == "Category 4") return arrC4;
      else if (this.model.ProductView == "Product Type") return arrPT;
      else if (this.model.ProductView == "Product Size") return arrPS;
      else if (this.model.ProductView == "Product") return arrP;
      else return [];
    },
    toolBarHeight() {
      if (document.getElementsByClassName("view-toolbar").length != 0)
        return document.getElementsByClassName("view-toolbar")[0].clientHeight;
      else return 56;
    },

    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",
        },
      ]);
    },
    // 15May2026 (AE) - #71165 : Type dropdown items.
    // Always include the three base values. Include
    // 'Automatic Invoice Surcharge Inclusion' only when the
    // ApplicationFeatureSetting master switch is Y, OR when the current
    // record is already of that type (so admins can review/edit it
    // even if the feature has since been turned off).
    typeDropdownItems() {
      const items = [
        { value: "Available Products", text: "Available Products" },
        { value: "Automatic Sales Order Inclusion", text: "Automatic Sales Order Inclusion" },
        { value: "Prompted Sales Despatch Inclusion", text: "Prompted Sales Despatch Inclusion" },
      ];
      if (
        this.automaticInvoiceSurchargeEnabled ||
        this.model.Type === "Automatic Invoice Surcharge Inclusion"
      ) {
        items.push({
          value: "Automatic Invoice Surcharge Inclusion",
          text: "Automatic Invoice Surcharge Inclusion",
        });
      }
      return items;
    },
    toolbarFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: this.parseFormColumns([
            {
              dataField: "Description",
              gcLabel: " ",
              gcType: "String",
              gcLabelVisible: false,
              validationRules: [
                {
                  type: "required",
                  message: "Description is required",
                },
              ],
              ref: "product-filter-group-name",
              cssClass: "toolbar-customer-label",
              editorType: "dxTextBox",
              editorOptions: {
                width: 300,
              },
            },
            {
              dataField: "Type",
              gcLabel: "Type",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                width: 250,
                items: this.typeDropdownItems,
                displayExpr: "text",
                valueExpr: "value",
                dropDownOptions: {
                  minWidth: 250,
                },
              },
            },
          ]),
        },
      ];
    },
    toolbarCustomerFormItems() {
      return [
        {
          dataField: "CustomerView",
          editorType: "dxSelectBox",
          label: { text: " " },
          editorOptions: {
            width: 200,
            items: [
              {
                value: "Review",
                text: "Review",
              },
              {
                value: "Customer Group",
                text: "Group",
              },
              {
                value: "Customer Type",
                text: "Type",
              },

              {
                value: "Customer",
                text: "Customer",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.currentCustomerView,
            onValueChanged: this.customerViewChanged,
          },
        },
      ];
    },
    toolbarProductFormItems() {
      return [
        {
          dataField: "ProductView",
          editorType: "dxSelectBox",
          label: { text: " " },
          editorOptions: {
            width: 200,
            items: [
              {
                value: "Review",
                text: "Review",
              },
              {
                value: "Category 1",
                text: "Category 1",
              },
              {
                value: "Category 2",
                text: "Category 2",
              },
              {
                value: "Category 3",
                text: "Category 3",
              },
              {
                value: "Category 4",
                text: "Category 4",
              },
              {
                value: "Product Type",
                text: "Type",
              },
              {
                value: "Product Size",
                text: "Size",
              },

              {
                value: "Product",
                text: "Product",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.currentProductView,
            onValueChanged: this.productViewChanged,
          },
        },
      ];
    },
    currentCustomerListKey() {
      if (this.currentCustomerView === "Review") {
        return "RecordId";
      }

      return "Code";
    },
    currentProductListKey() {
      if (this.currentProductView === "Review") {
        return "RecordId";
      }

      return "Code";
    },
    currentCustomerDescriptionDataField() {
      if (this.currentCustomerView === "Review") {
        return "Description";
      } else if (this.currentCustomerView === "Customer") {
        return "Name";
      } else {
        return "Description";
      }
    },

    currentCustomerCodeDataField() {
      if (this.currentCustomerView === "Review") {
        return "Value";
      }

      return "Code";
    },
    currentProductDescriptionDataField() {
      if (this.currentProductView === "Review") {
        return "Description";
      } else if (this.currentProductView === "Product") {
        return "Description1";
      } else {
        return "Description";
      }
    },

    currentProductCodeDataField() {
      if (this.currentProductView === "Review") {
        return "Value";
      }

      return "Code";
    },

    productFilterGroupProductColumns() {
      if (this.currentProductView === "Review") {
        return this.parseGridColumns("transaction", [
          {
            gcLabel: "Value",
            dataField: "Description",
            cellTemplate: "item-cell-template",
            gcType: "String",
            gcSubType: "PrimaryRecord",
          },
          {
            gcLabel: "Type",
            dataField: "Type",
            cellTemplate: "item-type-cell-template",
            gcType: "String",
            width: 200,
          },

          {
            gcLabel: "Value",
            dataField: "Value",
            width: 120,
            gcType: "String",
            gcSubType: "HiddenCode",
          },
        ]);
      } else {
        return this.parseGridColumns("transaction", [
          {
            gcLabel: this.model.ProductView,
            dataField: this.currentProductDescriptionDataField,
            cellTemplate: "item-cell-template",
            gcType: "String",
            gcSubType: "PrimaryRecord",
          },
          {
            gcLabel: "Code",
            dataField: "Code",
            width: 120,
            gcType: "String",
            gcSubType: "HiddenCode",
          },
        ]);
      }
    },
    productFilterGroupCustomerColumns() {
      if (this.currentCustomerView === "Review") {
        return this.parseGridColumns("transaction", [
          {
            gcLabel: "Value",
            dataField: "Description",
            cellTemplate: "cust-cell-template",
            gcType: "String",
            gcSubType: "PrimaryRecord",
            minWidth: 200,
          },
          {
            gcLabel: "Type",
            dataField: "Type",
            cellTemplate: "cust-type-cell-template",
            gcType: "String",
            width: 200,
          },

          {
            gcLabel: "Value",
            dataField: "Value",
            minWidth: 100,
            gcType: "String",
            gcSubType: "HiddenCode",
          },
        ]);
      } else {
        return this.parseGridColumns("transaction", [
          {
            gcLabel: this.model.CustomerView,
            dataField: this.currentCustomerDescriptionDataField,
            cellTemplate: "cust-cell-template",
            gcType: "String",
            gcSubType: "PrimaryRecord",
          },
          {
            gcLabel: "Code",
            dataField: "Code",
            width: 120,
            gcType: "String",
            gcSubType: "HiddenCode",
          },
        ]);
      }
    },

    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },

  methods: {
    formatCustomerType(type) {
      if (type == "CT") {
        return "Customer Type";
      } else if (type == "CG") {
        return "Customer Group";
      } else {
        return "Customer";
      }
    },
    formatProductType(type) {
      if (type == "PC1") {
        return "Category 1";
      } else if (type == "PC2") {
        return "Category 2";
      } else if (type == "PC3") {
        return "Category 3";
      } else if (type == "PC4") {
        return "Category 4";
      } else if (type == "PT") {
        return "Product Type";
      } else if (type == "PS") {
        return "Product Size";
      } else {
        return "Product";
      }
    },
    onEditorPreparing(e) {
      if (e.command == "select") {
        if (this.baseView.mode == "review") {
          e.editorOptions.readOnly = true;
          e.editorOptions.disabled = true;
          e.editorOptions.focusStateEnabled = false;
          e.editorOptions.hoverStateEnabled = false;
        }
      }
    },
    onCustomerGridSelectionChanged(e) {
      if (this.currentCustomerView == "Review") {
        this.productFilterGroupCustomers = [];
        e.selectedRowsData.forEach((obj) => {
          this.productFilterGroupCustomers.push({
            Type: obj.Type,
            Value: obj.Value,
            Description: obj.Description,
            RecordId: obj.RecordId,
          });
        });
        return;
      }

      if (this.baseView.mode == "review") {
        e.component.selectRows(this.customerGridKeys);
        return;
      }

      let data = e.selectedRowsData;
      let type = this.getSelectedCustomerViewCode();

      this.productFilterGroupCustomers = this.productFilterGroupCustomers.filter(
        (obj) => obj.Type !== type
      );

      data.forEach((obj) => {
        let index = this.productFilterGroupCustomers.findIndex(
          (c) => c.Type == type && c.Value == obj.Code
        );
        if (index > -1) {
          this.productFilterGroupCustomers.splice(index, 1);
        } else {
          this.productFilterGroupCustomers.push({
            Type: type,
            Value: obj.Code,
            Description: obj[this.currentCustomerDescriptionDataField],
            RecordId: obj.RecordId,
          });
        }
      });
    },
    onProductGridSelectionChanged(e) {
      if (this.currentProductView == "Review") {
        this.productFilterGroupProducts = [];

        e.selectedRowsData.forEach((obj) => {
          this.productFilterGroupProducts.push({
            Type: obj.Type,
            Value: obj.Value,
            Description: obj.Description,
            RecordId: obj.RecordId,
          });
        });
        return;
      }

      if (this.baseView.mode == "review") {
        e.component.selectRows(this.productGridKeys);
        return;
      }

      let data = e.selectedRowsData;
      let type = this.getSelectedProductViewCode();

      this.productFilterGroupProducts = this.productFilterGroupProducts.filter(
        (obj) => obj.Type !== type
      );

      data.forEach((obj) => {
        let index = this.productFilterGroupProducts.findIndex(
          (c) => c.Type == type && c.Value == obj.Code
        );
        if (index > -1) {
          this.productFilterGroupProducts.splice(index, 1);
        } else {
          this.productFilterGroupProducts.push({
            Type: type,
            Value: obj.Code,
            Description: obj[this.currentProductDescriptionDataField],
            RecordId: obj.RecordId,
          });
        }
      });
    },

    getSelectedProductViewCode() {
      if (this.currentProductView == "Review") {
        return "";
      } else if (this.currentProductView == "Category 1") {
        return "PC1";
      } else if (this.currentProductView == "Category 2") {
        return "PC2";
      } else if (this.currentProductView == "Category 3") {
        return "PC3";
      } else if (this.currentProductView == "Category 4") {
        return "PC4";
      } else if (this.currentProductView == "Product") {
        return "P";
      } else if (this.currentProductView == "Product Size") {
        return "PS";
      } else if (this.currentProductView == "Product Type") {
        return "PT";
      }
    },
    getSelectedCustomerViewCode() {
      if (this.currentCustomerView == "Review") {
        return "";
      } else if (this.currentCustomerView == "Customer") {
        return "C";
      } else if (this.currentCustomerView == "Customer Group") {
        return "CG";
      } else if (this.currentCustomerView == "Customer Type") {
        return "CT";
      }
    },
    backButtonFunction() {
      this.$router.push({
        path: "/product-filter-group",
      });
    },
    onToolbarPreparingProductFilterGroupProductGrid(e) {
      let toolbarItems = e.toolbarOptions.items;
      let searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,

        {
          widget: "dxForm",
          location: "before",
          // disabled: this.baseView.mode == "review" ? true : false,
          options: {
            formData: this.model,
            items: this.toolbarProductFormItems,
            validationGroup: "formsData",
            labelLocation: "left",
            showRequiredMark: false,
          },
          locateinmenu: "auto",
        }
      );
    },
    onToolbarPreparingProductFilterGroupCustomerGrid(e) {
      let toolbarItems = e.toolbarOptions.items;
      let searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,

        {
          widget: "dxForm",
          location: "before",
          // disabled: this.baseView.mode == "review" ? true : false,
          options: {
            formData: this.model,
            items: this.toolbarCustomerFormItems,
            labelLocation: "left",
          },
          locateinmenu: "auto",
        }
      );
    },
    async productViewChanged(e) {
      if (this.currentProductView == e.value) return;
      this.currentProductView = e.value;
      await this.loadProductViewData();
    },

    async customerViewChanged(e) {
      if (this.currentCustomerView == e.value) return;
      this.currentCustomerView = e.value;
      await this.loadCustomerViewData();
    },
    async loadProductViewData() {
      if (this.currentProductView == "Review") {
        this.productFilterGroupProductDataSourceConfig = this.productFilterGroupProducts;
      } else if (this.currentProductView == "Category 1") {
        this.productFilterGroupProductDataSourceConfig = this.category1DataSourceConfig;
      } else if (this.currentProductView == "Category 2") {
        this.productFilterGroupProductDataSourceConfig = this.category2DataSourceConfig;
      } else if (this.currentProductView == "Category 3") {
        this.productFilterGroupProductDataSourceConfig = this.category3DataSourceConfig;
      } else if (this.currentProductView == "Category 4") {
        this.productFilterGroupProductDataSourceConfig = this.category4DataSourceConfig;
      } else if (this.currentProductView == "Product") {
        this.productFilterGroupProductDataSourceConfig = this.productDataSourceConfig;
      } else if (this.currentProductView == "Product Size") {
        this.productFilterGroupProductDataSourceConfig = this.productSizeDataSourceConfig;
      } else if (this.currentProductView == "Product Type") {
        this.productFilterGroupProductDataSourceConfig = this.productTypeDataSourceConfig;
      }
    },
    async loadCustomerViewData() {
      if (this.currentCustomerView == "Review") {
        this.productFilterGroupCustomerDataSourceConfig = this.productFilterGroupCustomers;
      } else if (this.currentCustomerView == "Customer") {
        this.productFilterGroupCustomerDataSourceConfig = this.customerDataSourceConfig;
      } else if (this.currentCustomerView == "Customer Type") {
        this.productFilterGroupCustomerDataSourceConfig = this.customerTypeDataSourceConfig;
      } else if (this.currentCustomerView == "Customer Group") {
        this.productFilterGroupCustomerDataSourceConfig = this.customerGroupDataSourceConfig;
      }
    },
    async saveProductFilterGroup() {
      this.$logger.trackEventButtonClickSave();
      let validationResult = await validationEngine.validateGroup("formsData");

      if (!validationResult.isValid) {
        this.displayValidationSummary();
        return;
      }

      let payload = {
        Code: this.baseView.mode === "create" ? 0 : this.baseView.id,
        Description: this.model.Description,
        Type: this.model.Type,
        Inactive: this.model.Active ? "N" : "Y",
        ProductFilterGroupCustomers: this.productFilterGroupCustomers.map(
          (obj) => {
            return {
              Type: obj.Type,
              Value: obj.Value,
            };
          }
        ),
        ProductFilterGroupProducts: this.productFilterGroupProducts.map(
          (obj) => {
            return {
              Type: obj.Type,
              Value: obj.Value,
            };
          }
        ),
      };

      this.showLoading(true);

      try {
        let res = await ProductFilterGroupService.saveProductFilterGroup(
          payload
        );
        if (res) {
          let result = await ProductFilterGroupService.getProductFilterGroupByCode(
            res.data.Code
          );

          this.model.CreatedBy = result.data.value[0].CreatedBy;
          this.model.DateCreated = result.data.value[0].DateCreated;
          this.model.DateChanged = result.data.value[0].DateChanged;
          this.model.ChangedBy = result.data.value[0].ChangedBy;
          // let customersResponse = await ProductFilterGroupService.getProductFilterGroupCustomersByCode(
          //   res.data.Code
          // );
          // this.productFilterGroupCustomers = customersResponse.data.value;

          // let productsResponse = await ProductFilterGroupService.getProductFilterGroupProductsByCode(
          //   res.data.Code
          // );
          // this.productFilterGroupProducts = productsResponse.data.value;

          this.showLoading(false);
          this.$notify(
            `Product Filter Group ${res.data.Code} Successfully Saved`,
            "success"
          );

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-filter-group/review/${res.data.Code}`,
          });
        } else {
          let result = await ProductFilterGroupService.getProductFilterGroupByCode(
            this.baseView.id
          );

          this.model.CreatedBy = result.data.value[0].CreatedBy;
          this.model.DateCreated = result.data.value[0].DateCreated;
          this.model.DateChanged = result.data.value[0].DateChanged;
          this.model.ChangedBy = result.data.value[0].ChangedBy;
          // let customersResponse = await ProductFilterGroupService.getProductFilterGroupCustomersByCode(
          //   this.baseView.id
          // );
          // this.productFilterGroupCustomers = customersResponse.data.value;

          // let productsResponse = await ProductFilterGroupService.getProductFilterGroupProductsByCode(
          //   this.baseView.id
          // );
          // this.productFilterGroupProducts = productsResponse.data.value;
          this.showLoading(false);
          this.$notify(
            `Product Filter Group ${this.baseView.id} Successfully Updated`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-filter-group/review/${this.baseView.id}`,
          });
        }
      } catch (err) {
        this.displayServerError(err, "Save Product Filter Group Failed");
      }
    },
  },
};
</script>

<style lang="scss">
.css-v2.product-filter-group {
  padding: 12px;
  .view-toolbar .dx-form .dx-item-content .dx-item.dx-box-item {
    width: unset !important;
  }

  .split-container {
    padding-top: 12px;
    display: -webkit-box !important;
    > .split-container-child.left-container {
      margin-left: 0 !important;
    }
  }
  .product-filter-group-toolbar {
    .dx-toolbar-items-container {
      height: 45px;
      .dx-toolbar-before {
        padding-left: 1px !important;
      }
    }
  }
}
</style>
